import React, { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import Data from '../../../Data/Data.json';
import axios from "axios";
import SearInputG from "../../SearchInput"
import SelectOption from "../../SelectOption";
import { Crypter } from "../../../Functions/Security/Crypter";
import { Box, Typography } from '@mui/material';

let searchTerme: any = { CodeAgence: '', Table: "TERME", Colonne1: "CODE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 };
let searchPlancp: any = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 };
let searchCobac: any = { CodeAgence: '', Table: "REF_CATEGCOBAC", Colonne1: "CODE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 };
let searchUnite: any = { CodeAgence: '', Table: "v_period_lib", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '101', Choix: 22 };

const fieldDesc: Record<string, string> = {
    CODE: 'Code unique du terme.',
    lib_CODE: 'Nom explicite du terme.',
    UTILITE: 'Usage de la durée : à quoi sert ce terme dans la gamme des prêts.',
    DUREEMIN: 'Durée minimale autorisée en mois.',
    DUREEMAX: 'Durée maximale autorisée en mois.',
    NBRECHMAX: 'Nombre maximal d\'échéances autorisé pour ce terme.',
    CATEGCOBAC: 'Classification réglementaire COBAC/SESSEM.',
    PLENG: 'Plan comptable des engagements.',
    PLIMPAYE: 'Plan comptable des impayés client.',
    PLCRIMMO: 'Plan comptable des créances immobilisées client.',
    PLCRDOUT: 'Plan comptable des créances douteuses client.',
    PLINTIMP: 'Plan comptable des intérêts impayés client.',
    PLTVAIMP: 'Plan comptable de la TVA impayée client.',
    PLGARAN: 'Plan comptable des garanties client.',
    PLPROMESS: 'Plan comptable des promesses client.',
    PLINTDOUT: 'Plan comptable des intérêts hors bilan client.',
    PLPROV: 'Plan comptable des provisions client.',
    PLTVADOUT: 'Plan comptable de la TVA hors bilan client.',
    PLAGIOIMP: 'Plan comptable des agios impayés client.',
    PLPENIMP: 'Plan comptable des pénalités impayées client.',
};

const Terme = () => {
    const auth = useAuthUser();
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()));
    const authHeader = useAuthHeader();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("");
    const [Idbutton, setIdbutton] = useState(false);
    const [Idbutton2, setIdbutton2] = useState(true);

    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        setIdbutton(true);
        setIdbutton2(true);
    }

    function HandleAjout() {
        form.resetFields();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdbutton2(false);
    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('modif');
        setSupprime(true);
        setIdbutton2(false);
    }

    function HandleSupp() {
        setSbmit('supp');
    }

    function HandleAnnul() {
        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdbutton(false);
        setIdbutton2(true);
    }

    // Helpers de rendu - layout : label a gauche du champ
    const I = (label: string, name: string, type: any = 'text', money?: boolean, def?: any) =>
        <InputForm width={24} label={label} type={type} name={name} money={money} defaultValue={def} notRequired />;

    const Plan = (label: string, name: string) =>
        <SearchModal width={24} Titre="" Parametre={searchPlancp} label={label} name={name} Taille1="40%" Taille2="60%" form={form} />;

    const Sel = (label: string, name: string, parametre: any) =>
        <SelectOption width={24} label={label} name={name} Parametre={parametre} notRequired />;

    const Field = (children: any) => {
        const name = children?.props?.name;
        const desc = name ? fieldDesc[name] : undefined;
        const label = children?.props?.label;

        if (!label) {
            return (
                <Box title={desc} sx={{ minWidth: 0, width: '100%' }}>
                    {children}
                </Box>
            );
        }

        const child = React.cloneElement(children, { label: undefined, width: 0 });
        return (
            <Box title={desc} sx={{ display: 'grid', gridTemplateColumns: '35% minmax(0, 1fr)', gap: 1, alignItems: 'center', minWidth: 0}}>
                <Box sx={{ textAlign: 'left', pr: 1, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {label}
                </Box>
                <Box sx={{ minWidth: 0, width: '100%' }}>
                    {child}
                </Box>
            </Box>
        );
    };

    const Guide = (text: string) => (
        <Typography variant="caption" sx={{ display: 'block', mb: 2, color: '#555' }}>
            {text}
        </Typography>
    );

    const tabPanel = (title: string, guide: string, content: any) => (
        <div className='tabItem' style={{ display: 'block', width: '100%' }}>
            <fieldset className="bordure1" style={{ marginBottom: 12, width: '100%' }}>
                <legend style={{ fontSize: '15px', padding: '0 10px', color: '#116599' }}>{title}</legend>
                {Guide(guide)}
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 1.5 }}>
                    {content}
                </Box>
            </fieldset>
        </div>
    );

    const items: TabsProps['items'] = [
        {
            key: '1',
            forceRender: true,
            label: (<span><UserOutlined /> Identification</span>),
            children: tabPanel("Identification et durées",
                "Saisissez le code, le libellé, l'utilité et les bornes de durée du terme.",
                <>
                    {Field(<SearInputG
                        width={0}
                        dissabledLib={Idbutton2}
                        dissabledCode={Idbutton}
                        notremove
                        Titre="Recherche"
                        label="Terme"
                        name="CODE"
                        Taille1="100%"
                        Taille2="100%"
                        Parametre={searchTerme}
                        form={form}
                    />)}
                    {Field(I("Libellé", "lib_CODE"))}
                    {Field(Sel("Unité", "UTILITE", searchUnite))}
                    {Field(I("Durée min (mois)", "DUREEMIN", "number", false, 0))}
                    {Field(I("Durée max (mois)", "DUREEMAX", "number", false, 0))}
                    {Field(I("Nb échéances max", "NBRECHMAX", "number", false, 0))}
                    {Field(Sel("Catégorie COBAC", "CATEGCOBAC", searchCobac))}
                </>)
        },
        {
            key: '3',
            forceRender: true,
            label: (<span><ContactsOutlined /> Plans comptables client</span>),
            children: tabPanel("Plans comptables des comptes client",
                "Sélectionnez les plans comptables clients. Ils sont communs à tous les types de prêt de ce terme.",
                <>
                    {Field(Plan("Engagement", "PLENG"))}
                    {Field(Plan("Impayé", "PLIMPAYE"))}
                    {Field(Plan("Créance immobilisée", "PLCRIMMO"))}
                    {Field(Plan("Créance douteuse", "PLCRDOUT"))}
                    {Field(Plan("Intérêt impayé", "PLINTIMP"))}
                    {Field(Plan("TVA impayé", "PLTVAIMP"))}
                    {Field(Plan("Garantie", "PLGARAN"))}
                    {Field(Plan("Promesse", "PLPROMESS"))}
                    {Field(Plan("Intérêt hors bilan", "PLINTDOUT"))}
                    {Field(Plan("Provision", "PLPROV"))}
                    {Field(Plan("TVA hors bilan", "PLTVADOUT"))}
                    {Field(Plan("Agio impayé", "PLAGIOIMP"))}
                    {Field(Plan("Pénalité impayé", "PLPENIMP"))}
                </>)
        }
    ];

    function consult() {
        if (form.getFieldValue("CODE") == null) {
            SweetAlert.fire({ title: "Svp renseigner le code Terme", icon: "warning" });
        } else {
            let data = (form.getFieldValue("CODE"));
            HandleConsult();
            if (data.length != 0) {
                setLoading(true);
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadTerme,
                    headers: {
                        'CypherTerme': data + '|' + Perss.codage,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            let DemandVP = res.Result.Table[0];

                            if (res.StatutCode == 200) {
                                form.setFieldsValue(DemandVP);
                                form.setFieldValue("lib_CODE", DemandVP.LIBELLE);
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                            }
                        }
                        setLoading(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error);
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" });
                    });
            }
        }
    }

    const onFinish = (values: any) => {
        var Demand: any = {
            CODAGE: Perss.codage,
            CODE: form.getFieldValue("CODE"),
            LIBELLE: form.getFieldValue("lib_CODE"),
            UTILITE: form.getFieldValue("UTILITE"),
            DUREEMIN: parseInt(form.getFieldValue("DUREEMIN") ?? '0'),
            DUREEMAX: parseInt(form.getFieldValue("DUREEMAX") ?? '0'),
            NBRECHMAX: parseInt(form.getFieldValue("NBRECHMAX") ?? '0'),
            CATEGCOBAC: form.getFieldValue("CATEGCOBAC"),
            PLENG: form.getFieldValue("PLENG"),
            PLIMPAYE: form.getFieldValue("PLIMPAYE"),
            PLCRIMMO: form.getFieldValue("PLCRIMMO"),
            PLCRDOUT: form.getFieldValue("PLCRDOUT"),
            PLINTIMP: form.getFieldValue("PLINTIMP"),
            PLTVAIMP: form.getFieldValue("PLTVAIMP"),
            PLGARAN: form.getFieldValue("PLGARAN"),
            PLPROMESS: form.getFieldValue("PLPROMESS"),
            PLINTDOUT: form.getFieldValue("PLINTDOUT"),
            PLPROV: form.getFieldValue("PLPROV"),
            PLTVADOUT: form.getFieldValue("PLTVADOUT"),
            PLAGIOIMP: form.getFieldValue("PLAGIOIMP"),
            PLPENIMP: form.getFieldValue("PLPENIMP"),
            UTILIS: Perss.coduti,
        };

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'un Terme",
                text: "Voulez-vous Créer ce Terme ",
                showCancelButton: true,
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateTerme,
                        headers: {
                            'CypherTerme': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    SweetAlert.fire({ title: "Succès", text: res.Message, icon: "success" });
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }

        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "M.A.J d'un Terme",
                text: "Voulez-vous mettre à jour ce Terme ",
                showCancelButton: true,
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateTerme,
                        headers: {
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    setIsSubmit(false);
                                    HandleAnnul();
                                    SweetAlert.fire({ title: "Succès", text: res.Message, icon: "success" });
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }

        if (sbmit == "supp") {
            SweetAlert.fire({
                title: "Suppression d'un Terme",
                text: "Voulez-vous Supprimer ce Terme ",
                showCancelButton: true,
                confirmButtonText: "Oui",
                cancelButtonText: "Non",
                icon: "question"
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true);
                    let data = Crypter.encrypt(JSON.stringify(Demand.CODE));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteTerme,
                        headers: {
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode == 200) {
                                    setIsSubmit(false);
                                    HandleAnnul();
                                    SweetAlert.fire({ title: "Succès", text: res.Message, icon: "success" });
                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" });
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error);
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" });
                        });
                }
            });
        }
    };

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> Gestion des termes </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form
                    disabled={FormAct}
                    autoComplete="off"
                    layout="vertical"
                    labelAlign='left'
                    form={form}
                    name="terme_form"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block>Consulter</Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block>Ajouter</Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block>Modifier</Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>Enregistrer</Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>Supprimer</Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block>Actualiser</Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>Annuler</Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div style={{width: '88%'}}>
                            <Tabs
                                size='small'
                                type="card"
                                defaultActiveKey="1"
                                tabBarGutter={8}
                                tabBarStyle={{ overflowX: 'auto', whiteSpace: 'nowrap' }}
                                items={items}
                            />
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
};

export default Terme;
